import React, { createContext, useState, useMemo, useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Title } from '@fs/zion-head'

export const PageTitleContext = createContext()

export function PageTitleProvider({ children }) {
  const [pageTitle, setPageTitle] = useState('')
  const { t } = useTranslation()
  const value = useMemo(
    () => ({
      setPageTitle,
      pageTitle,
    }),
    [pageTitle, setPageTitle]
  )
  return (
    <PageTitleContext.Provider value={value}>
      {/*
        DATA-12448: react-helmet leaves document.title untouched once the last <title> unmounts, so
        any <NotFound> render used to strand "Page Not Found" in the browser tab -- including the
        transient one a deep link such as /temple/ctr/:ctrId/summary produces while the user's
        permissions are still resolving and the router has no matching route to offer yet. Keeping a
        <Title> mounted for the life of the app gives helmet something to fall back to. It renders
        ahead of `children`, so a genuine NotFound still outranks it while it is on screen.

        The tab deliberately carries only the app name; `pageTitle` names the current page in the
        SubHeader instead, where there is room for it.
      */}
      <Title>{t('app.title', 'Data Management Console')}</Title>
      {children}
    </PageTitleContext.Provider>
  )
}

export function usePageTitle(title) {
  const { setPageTitle } = useContext(PageTitleContext)

  useEffect(() => {
    setPageTitle(title)
  }, [title, setPageTitle])
}
